// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-BookingDetails-Flight-styles___flightDetails--MWxV7 {
  text-align: left;
  margin-bottom: 32px;
  border: 1px solid #dddee0;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
}

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___numbers--WJ0d4 {
    padding: 0 16px;
    color: #6d717a;
  }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___numbers--WJ0d4 .components-BookingDetails-Flight-styles___highlight--Dc4wV {
      color: #1b2432;
      font-weight: 600;
    }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___flightDetailsTitle--PvUXs {
    font-size: 17px;
    color: #1b2432;
    letter-spacing: 0;
    font-weight: 600;
  }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___row--QimJh {
    padding: 20px 0;
    border-bottom: 1px solid #c6c8cc;
  }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___row--QimJh.components-BookingDetails-Flight-styles___no-border--KiLqe {
      border: none;
    }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___row--QimJh.components-BookingDetails-Flight-styles___isLink--CO7X1 {
      cursor: pointer;
    }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___row--QimJh .components-BookingDetails-Flight-styles___baseFare--aiJzx {
      text-align: right;
      line-height: 22px;
    }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___row--QimJh .components-BookingDetails-Flight-styles___baseFare--aiJzx .components-BookingDetails-Flight-styles___baseprice--DQLpo {
        font-size: 15px;
        color: #1b2432;
        letter-spacing: 0;
        font-weight: 600;
      }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___row--QimJh .components-BookingDetails-Flight-styles___baseFare--aiJzx .components-BookingDetails-Flight-styles___price--NKReE {
        font-size: 13px;
        color: #1b2432;
        letter-spacing: 0;
        font-weight: normal;
      }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___title--smUQk {
    font-size: 15px;
  }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___subtitle--dbA_S {
    font-size: 13px;
  }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___cancelPolicyRow--mrx2C {
    display: flex;
  }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___cancelPolicyRow--mrx2C .components-BookingDetails-Flight-styles___cancelPolicy--zrYTN {
      flex: 1;
    }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___cancelPolicyRow--mrx2C .components-BookingDetails-Flight-styles___icon--vZWBf {
      color: #318afb;
    }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___withPrice--zyqYO {
    display: flex;
  }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___withPrice--zyqYO .components-BookingDetails-Flight-styles___title--smUQk,
    .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___withPrice--zyqYO .components-BookingDetails-Flight-styles___subtitle--dbA_S {
      flex: 1;
    }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___withPrice--zyqYO .components-BookingDetails-Flight-styles___title--smUQk svg, .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___withPrice--zyqYO .components-BookingDetails-Flight-styles___subtitle--dbA_S svg {
        margin-left: 6px;
        transition: transform 150ms ease;
      }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___withPrice--zyqYO .components-BookingDetails-Flight-styles___subtitle--dbA_S {
      padding-left: 16px;
    }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___withPrice--zyqYO .components-BookingDetails-Flight-styles___price--NKReE {
      color: #1b2432;
      font-weight: 600;
      font-size: 15px;
    }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___withPrice--zyqYO .components-BookingDetails-Flight-styles___price--NKReE.components-BookingDetails-Flight-styles___total--NHUkU {
        font-size: 21px;
        font-weight: 600;
      }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___dropdown--cv7H1 {
    padding-left: 15px;
  }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___rotate--cFjyl svg {
      transform: rotate(180deg);
    }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___buttonWrapper--Lk0qN {
    padding: 16px 0;
  }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___button--nsiNE {
    text-transform: initial;
    padding: 16px;
  }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___warning_container--Nmdy8 {
    display: flex;
    margin-top: 5px;
  }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___warning_container--Nmdy8 .components-BookingDetails-Flight-styles___warning--ROGvs {
      flex: 1;
      color: #6d717a;
      font-size: 13px;
      line-height: 17px;
      text-align: left;
      padding-bottom: 16px;
      padding-right: 15px;
    }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___warning_container--Nmdy8 .components-BookingDetails-Flight-styles___warning--ROGvs span {
        color: #fc3b60 !important;
      }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___warning_container--Nmdy8 .components-BookingDetails-Flight-styles___icon--vZWBf {
      color: #318afb;
    }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___warning_container--Nmdy8 div svg {
        cursor: pointer;
      }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___warning_container--Nmdy8 .components-BookingDetails-Flight-styles___multiWarning--bdr5V {
      flex: 1;
    }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___terms--VQNKa {
    color: #6d717a;
    font-size: 13px;
    line-height: 17px;
    text-align: center;
    padding-bottom: 16px;
  }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___terms--VQNKa span {
      font-weight: 500;
    }

  .components-BookingDetails-Flight-styles___flightDetails--MWxV7 .components-BookingDetails-Flight-styles___terms--VQNKa a {
      color: #318afb;
    }

.components-BookingDetails-Flight-styles___totalPrice--F5m89 {
  flex: 1;
  font-size: 17px;
  color: #1b2432;
  letter-spacing: 0;
}

.components-BookingDetails-Flight-styles___segmentDetail--BBDoP {
  border: none !important;
  webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.components-BookingDetails-Flight-styles___segmentDetail--BBDoP .components-BookingDetails-Flight-styles___container--MzY37 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 32px 32px 0 32px;
    font-weight: 300;
  }

.components-BookingDetails-Flight-styles___segmentDetail--BBDoP .components-BookingDetails-Flight-styles___container--MzY37 .components-BookingDetails-Flight-styles___destinations--SbdMg {
      font-size: 30px;
      color: #1b2432;
      letter-spacing: 0;
      min-width: 180px;
      align-self: end;
      margin-top: 15px;
    }

.components-BookingDetails-Flight-styles___segmentDetail--BBDoP .components-BookingDetails-Flight-styles___container--MzY37 .components-BookingDetails-Flight-styles___destinations--SbdMg svg {
        margin: 0 20px;
      }

.components-BookingDetails-Flight-styles___segmentDetail--BBDoP .components-BookingDetails-Flight-styles___container--MzY37 .components-BookingDetails-Flight-styles___details--HO2aa {
      font-size: 25px;
      color: #1b2432;
      letter-spacing: 0;
      margin: 0;
    }

.components-BookingDetails-Flight-styles___segmentDetail--BBDoP .components-BookingDetails-Flight-styles___container--MzY37 .components-BookingDetails-Flight-styles___labels--DO1qM {
      font-size: 11px;
      color: #6d717a;
      letter-spacing: 0;
      margin-bottom: 8px;
      margin-top: 0;
      font-weight: 400;
    }

.components-BookingDetails-Flight-styles___segmentDetail--BBDoP .components-BookingDetails-Flight-styles___container--MzY37 .components-BookingDetails-Flight-styles___logoContainer--asp7Y {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 10px;
    }

.components-BookingDetails-Flight-styles___segmentDetail--BBDoP .components-BookingDetails-Flight-styles___container--MzY37 .components-BookingDetails-Flight-styles___logoContainer--asp7Y .components-BookingDetails-Flight-styles___airline--pAkMp {
        margin-bottom: 0;
        margin-top: 0;
        font-size: 15px;
        color: #5f6670;
        letter-spacing: 0;
        font-weight: 400;
      }

.components-BookingDetails-Flight-styles___segmentDetail--BBDoP .components-BookingDetails-Flight-styles___container--MzY37 .components-BookingDetails-Flight-styles___logoContainer--asp7Y .components-BookingDetails-Flight-styles___logo--ZpA2J {
        height: 20px;
        width: 20px;
        border-radius: 50%;
        border: 1px solid #dddee0;
        margin-right: 5px;
      }

.components-BookingDetails-Flight-styles___segmentDetail--BBDoP .components-BookingDetails-Flight-styles___container--MzY37 .components-BookingDetails-Flight-styles___logoContainer--asp7Y .components-BookingDetails-Flight-styles___logo--ZpA2J img {
          height: 18px;
          width: auto;
          border-radius: 50%;
        }

.components-BookingDetails-Flight-styles___segmentDetail--BBDoP .components-BookingDetails-Flight-styles___container--MzY37 .components-BookingDetails-Flight-styles___confirmationNumber--NMOy8 {
      padding-right: 32px;
    }

.components-BookingDetails-Flight-styles___segmentDetail--BBDoP .components-BookingDetails-Flight-styles___container--MzY37 .components-BookingDetails-Flight-styles___confirmationNumber--NMOy8 .components-BookingDetails-Flight-styles___confNumb--YdnpK {
        margin-top: 5px;
        font-weight: 500;
      }

.components-BookingDetails-Flight-styles___segmentDetail--BBDoP .components-BookingDetails-Flight-styles___buttons--jaiEg .components-BookingDetails-Flight-styles___button--nsiNE {
      color: #318afb;
      min-width: 74px;
      height: 32px;
    }

.components-BookingDetails-Flight-styles___segmentDetail--BBDoP .components-BookingDetails-Flight-styles___flightDetailsPopupButton--wNFMZ {
    font-size: 15px;
    color: #318afb;
    letter-spacing: 0;
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
    margin-right: 32px;
    font-weight: 500;
    margin-top: 10px;
    padding-bottom: 32px;
    margin-left: 32px;
  }

.components-BookingDetails-Flight-styles___segmentDetail--BBDoP .components-BookingDetails-Flight-styles___flightDetailsPopupButton--wNFMZ .components-BookingDetails-Flight-styles___detailsLink--ZilFh {
      cursor: pointer;
      display: flex;
    }

.components-BookingDetails-Flight-styles___segmentDetail--BBDoP .components-BookingDetails-Flight-styles___flightDetailsPopupButton--wNFMZ button {
      text-decoration: none;
      margin-right: 11px;
    }

.components-BookingDetails-Flight-styles___segmentDetail--BBDoP .components-BookingDetails-Flight-styles___flightDetailsPopupButton--wNFMZ button svg {
        margin-left: 10px;
      }

.components-BookingDetails-Flight-styles___segmentDetail--BBDoP .components-BookingDetails-Flight-styles___flightDetailsPopupButton--wNFMZ .components-BookingDetails-Flight-styles___arrowLink--XMfPO {
      margin-left: 4px;
    }

.components-BookingDetails-Flight-styles___segmentDetail--BBDoP .components-BookingDetails-Flight-styles___withBorder--Iie9m {
    border-bottom: 1px solid #dddee0;
  }
`, "",{"version":3,"sources":["webpack://./components/BookingDetails/Flight/styles.pcss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,2CAA2C;AA+J7C;;EA7JE;IACE,eAAe;IACf,cAAc;EAMhB;;EAJE;MACE,cAAc;MACd,gBAAgB;IAClB;;EAGF;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gCAAgC;EA2BlC;;EAzBE;MACE,YAAY;IACd;;EAEA;MACE,eAAe;IACjB;;EAEA;MACE,iBAAiB;MACjB,iBAAiB;IAcnB;;EAZE;QACE,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,gBAAgB;MAClB;;EACA;QACE,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,mBAAmB;MACrB;;EAIJ;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EASf;;EAPE;MACE,OAAO;IACT;;EAEA;MACE,cAAc;IAChB;;EAGF;IACE,aAAa;EAyBf;;EAvBE;;MAEE,OAAO;IAKT;;EAJE;QACE,gBAAgB;QAChB,gCAAgC;MAClC;;EAGF;MACE,kBAAkB;IACpB;;EAEA;MACE,cAAc;MACd,gBAAgB;MAChB,eAAe;IAMjB;;EAJE;QACE,eAAe;QACf,gBAAgB;MAClB;;EAIJ;IACE,kBAAkB;EACpB;;EAGE;MACE,yBAAyB;IAC3B;;EAGF;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;EAwBjB;;EAvBE;MACE,OAAO;MACP,cAAc;MACd,eAAe;MACf,iBAAiB;MACjB,gBAAgB;MAChB,oBAAoB;MACpB,mBAAmB;IAIrB;;EAHE;QACE,yBAAyB;MAC3B;;EAEF;MACE,cAAc;IAChB;;EAEE;QACE,eAAe;MACjB;;EAEF;MACE,OAAO;IACT;;EAEF;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;EAStB;;EAPE;MACE,gBAAgB;IAClB;;EAEA;MACE,cAAc;IAChB;;AAIJ;EACE,OAAO;EACP,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAElC,2BAA2B;AAwH7B;;AAtHE;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,wBAAwB;IACxB,gBAAgB;EAoElB;;AAlEE;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,gBAAgB;IAKlB;;AAHE;QACE,cAAc;MAChB;;AAGF;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,SAAS;IACX;;AAEA;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,kBAAkB;MAClB,aAAa;MACb,gBAAgB;IAClB;;AAEA;MACE,aAAa;MACb,mBAAmB;MACnB,mBAAmB;MACnB,gBAAgB;IAuBlB;;AArBE;QACE,gBAAgB;QAChB,aAAa;QACb,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,gBAAgB;MAClB;;AACA;QACE,YAAY;QACZ,WAAW;QACX,kBAAkB;QAClB,yBAAyB;QACzB,iBAAiB;MAOnB;;AALE;UACE,YAAY;UACZ,WAAW;UACX,kBAAkB;QACpB;;AAIJ;MACE,mBAAmB;IAMrB;;AAJE;QACE,eAAe;QACf,gBAAgB;MAClB;;AAKF;MACE,cAAc;MACd,eAAe;MACf,YAAY;IACd;;AAGF;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;EAmBnB;;AAjBE;MACE,eAAe;MACf,aAAa;IACf;;AAEA;MACE,qBAAqB;MACrB,kBAAkB;IAKpB;;AAHE;QACE,iBAAiB;MACnB;;AAGF;MACE,gBAAgB;IAClB;;AAGF;IACE,gCAAgC;EAClC","sourcesContent":[".flightDetails {\n  text-align: left;\n  margin-bottom: 32px;\n  border: 1px solid #dddee0;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);\n\n  .numbers {\n    padding: 0 16px;\n    color: #6d717a;\n\n    .highlight {\n      color: #1b2432;\n      font-weight: 600;\n    }\n  }\n\n  .flightDetailsTitle {\n    font-size: 17px;\n    color: #1b2432;\n    letter-spacing: 0;\n    font-weight: 600;\n  }\n\n  .row {\n    padding: 20px 0;\n    border-bottom: 1px solid #c6c8cc;\n\n    &.no-border {\n      border: none;\n    }\n\n    &.isLink {\n      cursor: pointer;\n    }\n\n    .baseFare {\n      text-align: right;\n      line-height: 22px;\n\n      .baseprice {\n        font-size: 15px;\n        color: #1b2432;\n        letter-spacing: 0;\n        font-weight: 600;\n      }\n      .price {\n        font-size: 13px;\n        color: #1b2432;\n        letter-spacing: 0;\n        font-weight: normal;\n      }\n    }\n  }\n\n  .title {\n    font-size: 15px;\n  }\n\n  .subtitle {\n    font-size: 13px;\n  }\n\n  .cancelPolicyRow {\n    display: flex;\n\n    .cancelPolicy {\n      flex: 1;\n    }\n\n    .icon {\n      color: #318afb;\n    }\n  }\n\n  .withPrice {\n    display: flex;\n\n    .title,\n    .subtitle {\n      flex: 1;\n      svg {\n        margin-left: 6px;\n        transition: transform 150ms ease;\n      }\n    }\n\n    .subtitle {\n      padding-left: 16px;\n    }\n\n    .price {\n      color: #1b2432;\n      font-weight: 600;\n      font-size: 15px;\n\n      &.total {\n        font-size: 21px;\n        font-weight: 600;\n      }\n    }\n  }\n\n  .dropdown {\n    padding-left: 15px;\n  }\n\n  .rotate {\n    svg {\n      transform: rotate(180deg);\n    }\n  }\n\n  .buttonWrapper {\n    padding: 16px 0;\n  }\n\n  .button {\n    text-transform: initial;\n    padding: 16px;\n  }\n\n  .warning_container {\n    display: flex;\n    margin-top: 5px;\n    .warning {\n      flex: 1;\n      color: #6d717a;\n      font-size: 13px;\n      line-height: 17px;\n      text-align: left;\n      padding-bottom: 16px;\n      padding-right: 15px;\n      span {\n        color: #fc3b60 !important;\n      }\n    }\n    .icon {\n      color: #318afb;\n    }\n    div {\n      svg {\n        cursor: pointer;\n      }\n    }\n    .multiWarning {\n      flex: 1;\n    }\n  }\n  .terms {\n    color: #6d717a;\n    font-size: 13px;\n    line-height: 17px;\n    text-align: center;\n    padding-bottom: 16px;\n\n    span {\n      font-weight: 500;\n    }\n\n    a {\n      color: #318afb;\n    }\n  }\n}\n\n.totalPrice {\n  flex: 1;\n  font-size: 17px;\n  color: #1b2432;\n  letter-spacing: 0;\n}\n\n.segmentDetail {\n  border: none !important;\n  webkit-box-shadow: none !important;\n  -moz-box-shadow: none !important;\n  box-shadow: none !important;\n\n  .container {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    margin: 32px 32px 0 32px;\n    font-weight: 300;\n\n    .destinations {\n      font-size: 30px;\n      color: #1b2432;\n      letter-spacing: 0;\n      min-width: 180px;\n      align-self: end;\n      margin-top: 15px;\n\n      svg {\n        margin: 0 20px;\n      }\n    }\n\n    .details {\n      font-size: 25px;\n      color: #1b2432;\n      letter-spacing: 0;\n      margin: 0;\n    }\n\n    .labels {\n      font-size: 11px;\n      color: #6d717a;\n      letter-spacing: 0;\n      margin-bottom: 8px;\n      margin-top: 0;\n      font-weight: 400;\n    }\n\n    .logoContainer {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      margin-top: 10px;\n\n      .airline {\n        margin-bottom: 0;\n        margin-top: 0;\n        font-size: 15px;\n        color: #5f6670;\n        letter-spacing: 0;\n        font-weight: 400;\n      }\n      .logo {\n        height: 20px;\n        width: 20px;\n        border-radius: 50%;\n        border: 1px solid #dddee0;\n        margin-right: 5px;\n\n        img {\n          height: 18px;\n          width: auto;\n          border-radius: 50%;\n        }\n      }\n    }\n\n    .confirmationNumber {\n      padding-right: 32px;\n\n      .confNumb {\n        margin-top: 5px;\n        font-weight: 500;\n      }\n    }\n  }\n\n  .buttons {\n    .button {\n      color: #318afb;\n      min-width: 74px;\n      height: 32px;\n    }\n  }\n\n  .flightDetailsPopupButton {\n    font-size: 15px;\n    color: #318afb;\n    letter-spacing: 0;\n    display: flex;\n    justify-content: flex-end;\n    align-items: baseline;\n    margin-right: 32px;\n    font-weight: 500;\n    margin-top: 10px;\n    padding-bottom: 32px;\n    margin-left: 32px;\n\n    .detailsLink {\n      cursor: pointer;\n      display: flex;\n    }\n\n    button {\n      text-decoration: none;\n      margin-right: 11px;\n\n      svg {\n        margin-left: 10px;\n      }\n    }\n\n    .arrowLink {\n      margin-left: 4px;\n    }\n  }\n\n  .withBorder {\n    border-bottom: 1px solid #dddee0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flightDetails": `components-BookingDetails-Flight-styles___flightDetails--MWxV7`,
	"numbers": `components-BookingDetails-Flight-styles___numbers--WJ0d4`,
	"highlight": `components-BookingDetails-Flight-styles___highlight--Dc4wV`,
	"flightDetailsTitle": `components-BookingDetails-Flight-styles___flightDetailsTitle--PvUXs`,
	"row": `components-BookingDetails-Flight-styles___row--QimJh`,
	"noBorder": `components-BookingDetails-Flight-styles___no-border--KiLqe`,
	"isLink": `components-BookingDetails-Flight-styles___isLink--CO7X1`,
	"baseFare": `components-BookingDetails-Flight-styles___baseFare--aiJzx`,
	"baseprice": `components-BookingDetails-Flight-styles___baseprice--DQLpo`,
	"price": `components-BookingDetails-Flight-styles___price--NKReE`,
	"title": `components-BookingDetails-Flight-styles___title--smUQk`,
	"subtitle": `components-BookingDetails-Flight-styles___subtitle--dbA_S`,
	"cancelPolicyRow": `components-BookingDetails-Flight-styles___cancelPolicyRow--mrx2C`,
	"cancelPolicy": `components-BookingDetails-Flight-styles___cancelPolicy--zrYTN`,
	"icon": `components-BookingDetails-Flight-styles___icon--vZWBf`,
	"withPrice": `components-BookingDetails-Flight-styles___withPrice--zyqYO`,
	"total": `components-BookingDetails-Flight-styles___total--NHUkU`,
	"dropdown": `components-BookingDetails-Flight-styles___dropdown--cv7H1`,
	"rotate": `components-BookingDetails-Flight-styles___rotate--cFjyl`,
	"buttonWrapper": `components-BookingDetails-Flight-styles___buttonWrapper--Lk0qN`,
	"button": `components-BookingDetails-Flight-styles___button--nsiNE`,
	"warningContainer": `components-BookingDetails-Flight-styles___warning_container--Nmdy8`,
	"warning": `components-BookingDetails-Flight-styles___warning--ROGvs`,
	"multiWarning": `components-BookingDetails-Flight-styles___multiWarning--bdr5V`,
	"terms": `components-BookingDetails-Flight-styles___terms--VQNKa`,
	"totalPrice": `components-BookingDetails-Flight-styles___totalPrice--F5m89`,
	"segmentDetail": `components-BookingDetails-Flight-styles___segmentDetail--BBDoP`,
	"container": `components-BookingDetails-Flight-styles___container--MzY37`,
	"destinations": `components-BookingDetails-Flight-styles___destinations--SbdMg`,
	"details": `components-BookingDetails-Flight-styles___details--HO2aa`,
	"labels": `components-BookingDetails-Flight-styles___labels--DO1qM`,
	"logoContainer": `components-BookingDetails-Flight-styles___logoContainer--asp7Y`,
	"airline": `components-BookingDetails-Flight-styles___airline--pAkMp`,
	"logo": `components-BookingDetails-Flight-styles___logo--ZpA2J`,
	"confirmationNumber": `components-BookingDetails-Flight-styles___confirmationNumber--NMOy8`,
	"confNumb": `components-BookingDetails-Flight-styles___confNumb--YdnpK`,
	"buttons": `components-BookingDetails-Flight-styles___buttons--jaiEg`,
	"flightDetailsPopupButton": `components-BookingDetails-Flight-styles___flightDetailsPopupButton--wNFMZ`,
	"detailsLink": `components-BookingDetails-Flight-styles___detailsLink--ZilFh`,
	"arrowLink": `components-BookingDetails-Flight-styles___arrowLink--XMfPO`,
	"withBorder": `components-BookingDetails-Flight-styles___withBorder--Iie9m`
};
module.exports = ___CSS_LOADER_EXPORT___;
